// extracted by mini-css-extract-plugin
export var actions = "_qn-4";
export var item = "_qn-1";
export var price = "_qn-3";
export var quantity = "_qn-2";
export var table = "_qn-0";